import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  ADD_LANGUAGE,
  EDIT_LANGUAGE,
  LIST_LANGUAGE,
  VIEW_LANGUAGE,
  DELETE_LANGUAGE,

} from "./actionTypes"
import { languageSuccess, languageError } from "./actions"


import {
  onAddLanguage,
  onEditLanguage,
  onListLanguage,
  onViewLanguage,
  onSortLanguage,
  onDeleteLanguage,

} from "helpers/backend_api_helper";

// add Language
function* addLanguage({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddLanguage, data);
    yield put(languageSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(languageError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Language
function* editLanguage({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditLanguage, data, id);
    yield put(languageSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(languageError(error?.response?.data?.message || "Server Error"));
  }
}

// list Language
function* listLanguage({ payload: { data, callback } }) {
  try {
    const response = yield call(onListLanguage, data);
    yield put(languageSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(languageError(error?.response?.data?.message || "Server Error"));
  }
}

// view Language
function* viewLanguage({ payload: { data, history } }) {
  try {
    const response = yield call(onViewLanguage, data);
    yield put(languageSuccess(response));

  } catch (error) {
    yield put(languageError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Language
function* deleteLanguage({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteLanguage, data);
    yield put(languageSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(languageError(error?.response?.data?.message || "Server Error"));
  }
}



function* configLanguageSaga() {
  yield takeEvery(ADD_LANGUAGE, addLanguage);
  yield takeEvery(EDIT_LANGUAGE, editLanguage);
  yield takeEvery(LIST_LANGUAGE, listLanguage);
  yield takeEvery(VIEW_LANGUAGE, viewLanguage);
  yield takeEvery(DELETE_LANGUAGE, deleteLanguage);
}

export default configLanguageSaga;

